import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/app/app/_components/commons/HyundaiLanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/_styles/_mixins.scss");
;
import(/* webpackMode: "eager" */ "/app/app/_styles/_variables.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../public/fonts/PretendardVariable.woff2\",\"variable\":\"--font-pretendard\",\"display\":\"swap\"}],\"variableName\":\"pretendard\"}");
;
import(/* webpackMode: "eager" */ "/app/app/globals.scss");
;
import(/* webpackMode: "eager" */ "/app/app/reset.css");
